// src/pages/ProfileGate/steps/WelcomeStep.jsx

import React from "react";
import { useNavigate } from "react-router-dom";

import {
  OnboardingInterstitial,
} from "../OnboardingVisuals";

const WELCOME_PENGUIN_URL =
  "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/MVP4/Onboarding/Gwin_Wave.png";

export default function WelcomeStep() {
  const navigate =
    useNavigate();

  return (
    <OnboardingInterstitial
      message="Hello, I am Gwin."
      secondaryMessage=""
      showBack={false}
      showSpeechPenguin={false}
      nextLabel="Continue"
      onNext={() =>
        navigate(
          "/profile-gate/get-started"
        )
      }
    >
      <div className="mx-auto mt-9 w-[54%] max-w-[250px]">
        <img
          src={
            WELCOME_PENGUIN_URL
          }
          alt="Gwin"
          className="h-auto w-full object-contain"
          loading="eager"
          decoding="async"
          draggable="false"
        />
      </div>
    </OnboardingInterstitial>
  );
}